<div
  *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.Badge"
  appScaleDownText
  [scaleEnabled]="!(menu | isPrintMenu)"
  [style.color]="
    ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
      ? (section | textColorBasedOnSectionHeaderBackgroundColor)
      : (menu | productMenuBasicMethod: 'getSectionHeaderTextColor' : section)
  "
  class="section-header-general section-header-badge">
  {{ menu | getBadgeColumnTitle: section : colVm }}
</div>
